/**
 * Authentication cleanup utilities to prevent auth limbo states
 */

export const cleanupAuthState = () => {
  try {
    // Clear all Supabase auth-related keys from localStorage
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
        localStorage.removeItem(key);
      }
    });

    // Clear from sessionStorage if it exists
    if (typeof sessionStorage !== 'undefined') {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
          sessionStorage.removeItem(key);
        }
      });
    }

    // Clear any other auth-related data
    localStorage.removeItem('supabase.auth.token');
  } catch (error) {
    // Continue silently on cleanup errors
  }
};